<template>
  <!-- <ion-content class="noScroll"> -->
  <ion-content>
    <div id="mapBox"></div>
  </ion-content>
</template>

<script>
// @ is an alias to /src
//import mapboxgl from "mapbox-gl/dist/mapbox-gl.js";
import mapboxgl from 'mapbox-gl'
import { MapeventBus } from "../../util/MapEventBus.js";
import { mapState } from "vuex";
import { DeviceEventBus } from "../../DeviceEventBus";
import * as turf from "@turf/turf";
import { constants } from "fs";
export default {
  name: "mapBox",
  data() {
    return {
      mapBox: null,
      currentBound: null
    };
  },
  created() {
    // console.log('mapBox Created');
    //  this.createMap();
  },
  mounted() {
    // console.log('mapBox mounted  ');
    // console.log(this.$store.state.mapStore.defaultMapStyle.style );
    // console.log(this.mapStyle);
    this.createMap();
    DeviceEventBus.$on("orientation", this.handleOrientation);
  },
  methods: {
    handleOrientation(e) {
      try {
        console.log("Map handleOrientation  resizing");
        setTimeout(()=>{
           this.mapBox.resize()
           window.dispatchEvent(new Event('resize'))
           console.log("Map handleOrientation After ReSizing");
           this.calculateBound();
        },300)
       
      } catch (oerr) {
        console.log("-------handleOrientation Error -----------")
        console.log(oerr);
        console.log("-------------------------------------------\n")
      }
    },
    createMap() {
      // console.log('map createMap, ')
      mapboxgl.accessToken = process.env.VUE_APP_MapBox_accessToken;
      this.mapBox = new mapboxgl.Map({
        container: "mapBox", // container id
        style: this.mapStyle, //this.$store.state.mapStore.defaultMapStyle.style, // stylesheet location .
        center: [-81.055, 29.18], // starting position [lng, lat]
        zoom: 3, // starting zoom
        logoPosition: "top-left",
        attributionControl:true
      });
      // disable map rotation using right click + drag
      this.mapBox.dragRotate.disable();
      // disable map rotation using touch rotation gesture
      this.mapBox.touchZoomRotate.disableRotation();

      MapeventBus.map = this.mapBox;
      this.$store.dispatch("mapStore/setMap", this.mapBox);
      this.setMapListener();
      setTimeout(() => {
        this.mapBox.resize();
         this.calculateBound()
      }, 300);
    },
    setMapListener() {
      //  console.log('setMapListener');
      this.mapBox.on("mousemove", e => {
        //  console.log("MapBox:on:mousemove")
        MapeventBus.$emit("mousemove", e);
        this.$store.dispatch("mapStore/setMouseMove", e);
      });
      this.mapBox.on("zoomstart", e => {
        // console.log("MapBox:on:zoomstart")
        MapeventBus.$emit("zoomstart", e);
        this.$store.dispatch("mapStore/setZoomStart", e);
      });

      this.mapBox.on("zoomend", e => {
        // console.log("MapBox:on:zoomend")
        MapeventBus.$emit("zoomend", e);
        this.$store.dispatch("mapStore/setZoomEnd", e.lngLat);

        this.calculateBound();
      });
      this.mapBox.on("dragstart", e => {
        // console.log("MapBox:on:drag")
        MapeventBus.$emit("dragstart", e);
        this.$store.dispatch("mapStore/setDragStart", e);
      });
      this.mapBox.on("dragend", e => {
        // console.log("MapBox:on:dragend")
        MapeventBus.$emit("dragend", e);
        this.$store.dispatch("mapStore/setDragEnd", e);
        this.calculateBound();
      });
      this.mapBox.on("touchstart", e => {
        // console.log("MapBox:on:touchstart");
      });
      this.mapBox.on("touchend", e => {
        // console.log("MapBox:on:touchend");
      });
      this.mapBox.on("click", e => {
        // console.log('MapBox:on:click')
        MapeventBus.$emit("click", e);
        this.$store.dispatch("mapStore/setClick", e);
      });
      this.mapBox.on("load", e => {
        //  console.log("MapBox:on:load")
        MapeventBus.$emit("load", e) //
        setTimeout(() => {
          this.mapBox.resize()
           this.calculateBound()
        }, 300);
      });
      this.mapBox.on("style.load", e => {
        // console.log("MapBox:on:style.load")
        // console.log("style.load",e);

        MapeventBus.$emit("style.load", e);
        this.$store.dispatch("mapStore/setStyleLoaded", e);
        this.calculateBound();
      });

      // this.mapBox.on("resize", e => {
      //    console.log('A resize event occurred.');
        
      // })
    },
    calculateBound() {
      //  console.log("calculateBound");
      let b = this.mapBox.getBounds();
      let bbox = [b._sw.lng, b._sw.lat, b._ne.lng, b._ne.lat];
      let poly = turf.bboxPolygon(bbox);

      //Testing Poly Diff
      // if (this.currentBound) {
      //   let diff = turf.difference(this.currentBound, poly);
      //    console.log("diff")
      //    console.log(diff)
      // }

      this.currentBound = poly;
      this.$store.dispatch("mapStore/setBounds", this.currentBound);
     
    }
  },
  computed: mapState({
    mapStyle: state => state.mapStore.mapStyle.style
  })
};
</script>

<style scoped>

#mapBox {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  
}



</style>


